import { onMounted } from '@nuxtjs/composition-api';

export const useLoadAnimation = () => {
  onMounted(() => {
    const targets = document.getElementsByClassName('js-animation');
    for (let i = 0; i < targets.length; i++) {
      targets[i].classList.add('-animation-start');
    }
  });
};
